var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgKeypointDisabled = function SvgKeypointDisabled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.10049,
    y: 18,
    width: 14,
    height: 14,
    rx: 2,
    transform: "rotate(-45 8.10049 18)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14H19V17H22V19H19V22H17V19H14V17H17V14Z",
    fill: "white"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKeypointDisabled);
export { ForwardRef as ReactComponent };